module.exports = __webpack_public_path__ + "img/about.190d1c2e.jpg";